module.exports = __webpack_public_path__ + "img/deezer.e1524107.svg";